
import Vue from 'vue'
import CommonGroupListing from '../common/group/CommonGroupListing.vue'

export default Vue.extend({
  name: 'AdminGroupManagement',
  extends: CommonGroupListing,
})
